export default __webpack_public_path__ + "static/media/rice-wheat-icon.7b6a70e6.svg";